import { Component, Input, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AlarmService} from "../../../@core/data/alarm.service";
import {TranslateJsonService} from "../../../@core/data/translate-json.service";
import {TranslateService} from "@ngx-translate/core";
import {DataService} from "../../../@core/data/data.service";
import {Alarm} from "../../../@core/models";

@Component({
    selector: 'alarm-history-table',
    templateUrl: './alarm-history.component.html',
    styleUrls: ['./alarm-history.component.scss']
})



export class AlarmHistoryComponent implements OnChanges {
    @Input() alarms: Alarm[] = [];
    public alarmReference = new Alarm();
    alertsHistory: any[] = [];
    loading = false;
    error = '';

    constructor(
        private alarmService: AlarmService,
        private dataService: DataService,
        public translateJsonService: TranslateJsonService,
        protected translateService: TranslateService
        ) { }

    ngOnChanges(): void {
        if (this.alarms && this.alarms.length > 0) {
            this.alarmReference = this.alarms.reduce((latest, current) =>
                new Date(current.datetime) > new Date(latest.datetime) ? current : latest
            );
            this.fetchAlerts();
        }
    }

    fetchAlerts(): void {
        this.loading = true;
        this.error = '';
        const isoDatetime = this.alarmReference.datetime instanceof Date
            ? this.alarmReference.datetime.toISOString()
            : new Date(this.alarmReference.datetime).toISOString();
        this.alarmService.getHistoryByImeiAndReferenceDate(this.alarmReference.imei
            , this.alarmReference.vehicleId
            , isoDatetime).subscribe({
            next: (data) => {
                this.alertsHistory = data
                    .filter(alert => !this.alarms.some(alarm => alarm.id === alert.id))
                    .map(alertsHistory => ({
                    ...alertsHistory,
                    alarmType: this.dataService.alarmTypesNumber[
                        this.dataService.alarmTypesNumber.findIndex(type => type.value == alertsHistory.typeAlarm)
                    ],
                    originalTypeAlarm: this.dataService.alarmTypesNumber[
                        this.dataService.alarmTypesNumber.findIndex(type => type.value == alertsHistory.originalTypeAlarm)
                    ],
                }))
                    .sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                this.loading = false;
            },
            error: () => {
                this.error = 'Erro ao carregar os alertas';
                this.loading = false;
            }
        });
    }
}